import React, { useState } from 'react'
import { DettagliPageConfig } from '../../configuration'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/photoFrame.styles'
import Popover from './Popover'
// import popoverImg from './assets/images/popover.png'
import { useMediaQuery } from '@material-ui/core'
import FadeInHOC from '../FadeInHOC'

const useStyles = makeStyles(styles)

export default function PhotoFrame() {
    const initialState = {
        first: false,
        second: false,
        third: false,
        fourth: false
    }
    const [state, setState] = useState(initialState)
    const isMobile = useMediaQuery('(max-width: 760px)')
    const handleOpen = (e, key) => {
        setState({ initialState, [key]: e.currentTarget })
    }
    const handleClose = key => {
        setState({ ...initialState, [key]: null })
    }
    const classes = useStyles()
    return (
        <FadeInHOC rootClass={classes.root} seconds={3} >
            <Popover
                x='18%'
                y='80%'
                title={DettagliPageConfig.titles[2]}
                content={DettagliPageConfig.contents[2]}
                open={Boolean(state.first)}
                name='first'
                anchorEl={state.first}
                handleClose={handleClose}
                handleOpen={handleOpen}
                img={DettagliPageConfig.images[2]}
            />
            <Popover
                x='50%'
                y='30%'
                title={DettagliPageConfig.titles[1]}
                content={DettagliPageConfig.contents[1]}
                open={Boolean(state.second)}
                name='second'
                anchorEl={state.second}
                handleClose={handleClose}
                handleOpen={handleOpen}
                img={DettagliPageConfig.images[1]}
            />
            <Popover
                x='60%'
                y='75%'
                title= {DettagliPageConfig.titles[0]}
                content={DettagliPageConfig.contents[0]}
                open={Boolean(state.third)}
                name='third'
                anchorEl={state.third}
                handleClose={handleClose}
                handleOpen={handleOpen}
                img={DettagliPageConfig.images[0]}
            />
            <Popover
                x='30%'
                y='25%'
                title={DettagliPageConfig.titles[3]}
                content={DettagliPageConfig.contents[3]}
                open={Boolean(state.fourth)}
                name='fourth'
                anchorEl={state.fourth}
                handleClose={handleClose}
                handleOpen={handleOpen}
                img={DettagliPageConfig.images[3]}
            />
            {/* {isMobile && (
                <>
                    <Popover
                        x='10%'
                        y='80%'
                        content='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.'
                        anchorEl={state.third}
                        name='third'
                        open={Boolean(state.third)}
                        handleClose={handleClose}
                        handleOpen={handleOpen}
                        img={popoverImg}
                    />
                    <Popover
                        x='80%'
                        y='50%'
                        content='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.'
                        open={Boolean(state.fourth)}
                        name='fourth'
                        anchorEl={state.fourth}
                        handleClose={handleClose}
                        handleOpen={handleOpen}
                        img={popoverImg}
                    />
                </>
            )} */}
            <img className={classes.img} alt='cuisine' src={DettagliPageConfig.showPhoto} />
        </FadeInHOC>
    )
}
